





















import Vue from "vue";
export default Vue.extend({
  name: "CookieBanner",
  methods: {
    consentCookie: function(): void {
      this.$emit("consent");
    }
  }
});
